<template>
    <div>
        <div v-for="(item, index) in value" :key="index" class="d-flex align-baseline">
            <RecursivePayloadOnSchemaEditor
              :schema="item_schema"
              :readonly="readonly"
              :key_to_show="(index + 1).toString()"
              v-model="value[index]"
              :depth="depth+1"
              @change="payloadChanged"
            />
            <button icon small v-if="!readonly" @click="removeItem(index)">
                <v-icon class="red--text">mdi-close</v-icon>
            </button>
        </div>
        <button icon small  v-if="!readonly" @click="addItem"  :style="{ marginLeft: depth*20 + 'px' }" >
            <v-icon class="primary_blue--text">mdi-plus</v-icon>
        </button>
      </div>
</template>

<script>
export default {
  name: "ListOnSchemaEditor",
  components: {
    RecursivePayloadOnSchemaEditor: () => import("./RecursivePayloadOnSchemaEditor.vue"),
  },
  props: {
    item_schema: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    depth: {
      type: Number,
      default: 0,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    addItem() {
      let type = this.item_schema.type;
      let item = null;
      if (type === "object") {
        item = {};
      } else if (type === "array") {
        item = [];
      } else if (type === "string") {
        item = "";
      }
      this.value.push(item);
      this.payloadChanged();
    },
    removeItem(index) {
      this.value.splice(index, 1);
      this.payloadChanged();
    },
    payloadChanged() {
      console.log('payloadChanged IN LIST')
      //this.$emit("input", this.value);
      this.$emit("change", this.value);
    },

  }
};
</script>

<style scoped>
.nested-section {
  padding-left: 10px;
  border-left: 1px solid #ccc;
  margin-top: 10px;
}
</style>styleaddItem() {
      this.items.push({});
    },
    removeItem(index) {
      this.items.splice(index, 1);
    }